import React, { useState } from "react"

export const createModalSystem = ()=>{
    const [modals, setModals] = useState<React.ReactNode[]>([]);

    return {
        modals, 
        callModal: (modal: (close: ()=>void)=>React.ReactNode)=>{
            const modalView = modal(()=>{
                setModals(last=>last.filter(it=>it != modalView))
            });
            setModals((last)=>[...last, modalView]);
        }
    }
}
